import React from 'react';

const C = {
  bg: '#040000', bg2: '#0e0101', bg3: '#180303',
  gold: '#f5c842', gold2: '#d4a843', gold3: '#b8922e',
  red: '#cc0000', red2: '#880000',
  cream: '#f0e6cc', cream2: '#c8b89a', muted: '#8a7060',
  border: 'rgba(212,168,67,0.15)',
};

const styles = {
  page: { background: C.bg, minHeight: '100vh', color: C.cream, fontFamily: "'Barlow', sans-serif", overflowX: 'hidden' },
  // Header
  header: { position: 'sticky', top: 0, zIndex: 100, background: 'rgba(4,0,0,0.97)', backdropFilter: 'blur(20px)', borderBottom: `1px solid ${C.border}`, padding: '0 4%', height: '66px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  backBtn: { background: 'none', border: `1px solid ${C.border}`, color: C.gold2, padding: '7px 18px', borderRadius: '20px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '13px', fontWeight: '700', letterSpacing: '1px', transition: 'all 0.2s' },
  logoText: { fontFamily: "'Cinzel', serif", fontSize: '1.3em', fontWeight: '900', color: C.gold, letterSpacing: '4px', textShadow: `0 0 20px rgba(245,200,66,0.4)` },
  // Hero
  hero: { position: 'relative', padding: '100px 6%', background: `linear-gradient(135deg, #0e0101, #1a0303)`, borderBottom: `1px solid ${C.border}`, overflow: 'hidden' },
  heroBg: { position: 'absolute', inset: 0, background: 'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(180,0,0,0.2), transparent)', pointerEvents: 'none' },
  heroEyebrow: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: '800', letterSpacing: '4px', color: C.gold2, marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' },
  heroDot: { width: '6px', height: '6px', borderRadius: '50%', background: C.red, boxShadow: `0 0 8px ${C.red}` },
  heroTitle: { fontFamily: "'Cinzel', serif", fontSize: 'clamp(2.2em, 5vw, 4em)', fontWeight: '900', color: C.gold, letterSpacing: '3px', lineHeight: 1.15, marginBottom: '20px', textShadow: `0 0 40px rgba(245,200,66,0.3)` },
  heroSub: { fontSize: 'clamp(1em, 1.5vw, 1.2em)', color: C.cream2, lineHeight: 1.7, maxWidth: '600px', borderLeft: `3px solid ${C.gold2}`, paddingLeft: '20px' },
  heroRule: { width: '80px', height: '2px', background: `linear-gradient(90deg, ${C.gold}, transparent)`, margin: '24px 0' },
  // Sections
  section: { padding: '80px 6%' },
  sectionDark: { padding: '80px 6%', background: C.bg2 },
  sectionHead: { marginBottom: '50px' },
  sectionEyebrow: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '10px', fontWeight: '800', letterSpacing: '4px', color: C.gold2, marginBottom: '10px' },
  sectionTitle: { fontFamily: "'Cinzel', serif", fontSize: 'clamp(1.6em, 3vw, 2.4em)', fontWeight: '900', color: C.gold, letterSpacing: '2px', marginBottom: '12px' },
  sectionRule: { width: '60px', height: '2px', background: `linear-gradient(90deg, ${C.gold}, transparent)`, marginBottom: '16px' },
  sectionSub: { color: C.cream2, fontSize: '15px', lineHeight: 1.6 },
  // Cards
  grid2: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' },
  grid3: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' },
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' },
  card: { background: `linear-gradient(135deg, #1a0303, #0e0101)`, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '32px', transition: 'all 0.3s', position: 'relative', overflow: 'hidden' },
  cardIcon: { fontSize: '2em', marginBottom: '16px' },
  cardTitle: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1.4em', fontWeight: '800', letterSpacing: '2px', color: C.gold, marginBottom: '12px' },
  cardText: { color: C.cream2, lineHeight: 1.7, fontSize: '14px' },
  // Timeline
  timeline: { display: 'flex', flexDirection: 'column', gap: '0' },
  timelineItem: { display: 'flex', gap: '24px', paddingBottom: '40px', position: 'relative' },
  timelineLeft: { display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 },
  timelineDot: { width: '16px', height: '16px', borderRadius: '50%', background: C.gold, border: `3px solid ${C.bg2}`, boxShadow: `0 0 12px rgba(212,168,67,0.5)`, zIndex: 1 },
  timelineLine: { width: '2px', flex: 1, background: `linear-gradient(180deg, ${C.gold2}, transparent)`, marginTop: '4px' },
  timelineTitle: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1.2em', fontWeight: '800', letterSpacing: '2px', color: C.gold, marginBottom: '8px' },
  timelineText: { color: C.cream2, lineHeight: 1.7, fontSize: '14px' },
  // Team
  teamCard: { background: `linear-gradient(135deg, #1a0303, #0e0101)`, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '32px', textAlign: 'center', transition: 'all 0.3s' },
  teamAvatar: { width: '72px', height: '72px', borderRadius: '50%', background: `linear-gradient(135deg, ${C.red2}, #4a0000)`, border: `2px solid ${C.gold2}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2em', margin: '0 auto 16px' },
  teamName: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1.2em', fontWeight: '800', letterSpacing: '1px', color: C.gold, marginBottom: '4px' },
  teamRole: { color: C.gold3, fontSize: '12px', letterSpacing: '2px', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '700', marginBottom: '12px' },
  // Contact
  contactCard: { background: `linear-gradient(135deg, #1a0303, #0e0101)`, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '32px' },
  contactTitle: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1.3em', fontWeight: '800', letterSpacing: '2px', color: C.gold, marginBottom: '20px' },
  link: { color: C.gold2, textDecoration: 'none', fontSize: '14px', transition: 'color 0.2s', display: 'block', marginBottom: '4px' },
  socialBtn: { display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(212,168,67,0.08)', border: `1px solid ${C.border}`, color: C.gold2, padding: '10px 18px', borderRadius: '20px', textDecoration: 'none', fontSize: '13px', fontWeight: '700', fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '1px', margin: '6px 8px 6px 0', transition: 'all 0.2s', cursor: 'pointer' },
  // Category card
  catCard: { background: `linear-gradient(135deg, #1a0303, #0e0101)`, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '28px 24px', textAlign: 'center', transition: 'all 0.3s' },
  catIcon: { fontSize: '2.2em', marginBottom: '14px', display: 'block' },
  catTitle: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1.2em', fontWeight: '800', letterSpacing: '2px', color: C.gold, marginBottom: '8px' },
  catText: { color: C.cream2, fontSize: '13px', lineHeight: 1.6 },
  // Footer
  footer: { background: C.bg2, borderTop: `1px solid ${C.border}`, padding: '32px 6%', textAlign: 'center' },
  footerLogo: { fontFamily: "'Cinzel', serif", fontSize: '1.3em', fontWeight: '900', color: C.gold, letterSpacing: '4px', marginBottom: '8px', textShadow: `0 0 20px rgba(245,200,66,0.3)` },
  footerSub: { color: C.muted, fontSize: '13px', letterSpacing: '1px' },
};

function About({ onBack }) {
  return (
    <div style={styles.page}>
      {/* Header */}
      <header style={styles.header}>
        <button style={styles.backBtn} onClick={onBack} onMouseEnter={e => { e.target.style.borderColor = C.gold; e.target.style.color = C.gold; }} onMouseLeave={e => { e.target.style.borderColor = C.border; e.target.style.color = C.gold2; }}>← Back</button>
        <span style={styles.logoText}>NETHAJI PRIME</span>
        <div style={{ width: '80px' }} />
      </header>

      {/* Hero */}
      <section style={styles.hero}>
        <div style={styles.heroBg} />
        <div style={{ ...styles.heroEyebrow }}><span style={styles.heroDot} /> ABOUT NETHAJI PRIME OTT</div>
        <h1 style={styles.heroTitle}>Nethaji Prime OTT<br /><span style={{fontSize:"0.55em",letterSpacing:"2px",color:"#d4a843"}}>Politics · Astrology · Law · Entertainment</span></h1>
        <div style={styles.heroRule} />
        <p style={styles.heroSub}>Your premier Tamil streaming destination — Politics, Astrology, Law, Entertainment and more, all in one place.</p>
        {/* Gold particles */}
        {[...Array(6)].map((_, i) => (
          <div key={i} style={{ position: 'absolute', width: '3px', height: '3px', borderRadius: '50%', background: C.gold, opacity: 0.4, left: `${10 + i * 15}%`, top: `${20 + (i % 3) * 20}%`, boxShadow: `0 0 8px ${C.gold}` }} />
        ))}
      </section>

      {/* Mission & Vision */}
      <section style={styles.section}>
        <div style={styles.sectionHead}>
          <div style={styles.sectionEyebrow}>PURPOSE</div>
          <h2 style={styles.sectionTitle}>Mission & Vision</h2>
          <div style={styles.sectionRule} />
        </div>
        <div style={styles.grid2}>
          {[
            { icon: '🎯', title: 'OUR MISSION', text: 'Nethaji Prime is built to preserve and celebrate the rich legacy of Tamil political thought. We bring together rare speeches, historical moments, and powerful addresses that have shaped Tamil Nadu\'s political landscape.\n\nOur mission is to make this invaluable content accessible to everyone — students, researchers, activists, and citizens who want to understand the roots of Tamil political culture.' },
            { icon: '🔭', title: 'OUR VISION', text: 'We envision a world where Tamil political history is never forgotten. Where the words of great leaders continue to inspire new generations. Where the Dravidian movement, its struggles and triumphs, live on forever in the digital age.\n\nNethaji Prime aims to become the definitive platform for Tamil political content — a living, growing archive that honors the past while inspiring the future.' },
          ].map((item, i) => (
            <div key={i} style={styles.card} onMouseEnter={e => { e.currentTarget.style.borderColor = C.gold2; e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = `0 20px 60px rgba(0,0,0,0.5)`; }} onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: `linear-gradient(90deg, transparent, ${C.gold2}, transparent)` }} />
              <div style={styles.cardIcon}>{item.icon}</div>
              <h2 style={styles.cardTitle}>{item.title}</h2>
              {item.text.split('\n\n').map((p, j) => <p key={j} style={{ ...styles.cardText, marginBottom: '12px' }}>{p}</p>)}
            </div>
          ))}
        </div>
      </section>

      {/* Our Story */}
      <section style={styles.sectionDark}>
        <div style={styles.sectionHead}>
          <div style={styles.sectionEyebrow}>HISTORY</div>
          <h2 style={styles.sectionTitle}>Our Story</h2>
          <div style={styles.sectionRule} />
        </div>
        <div style={styles.timeline}>
          {[
            { title: 'The Beginning', text: 'Nethaji Prime was born from a simple observation — that decades of powerful Tamil political speeches were scattered, inaccessible, or at risk of being lost forever. We set out to change that.' },
            { title: 'Building the Archive', text: 'We began curating and digitizing speeches from key moments in Tamil political history — from the Dravidian movement\'s early days to the present, capturing the voices that shaped a generation.' },
            { title: 'Today', text: 'Nethaji Prime is now a growing platform with content available on web and mobile, serving Tamil communities across India and around the world. Our archive grows every day.' },
            { title: 'The Future', text: 'We are building AI-powered tools to transcribe, translate, and make Tamil political content searchable in multiple languages — so no speech is ever out of reach.' },
          ].map((item, i, arr) => (
            <div key={i} style={styles.timelineItem}>
              <div style={styles.timelineLeft}>
                <div style={styles.timelineDot} />
                {i < arr.length - 1 && <div style={styles.timelineLine} />}
              </div>
              <div style={{ paddingBottom: '8px' }}>
                <h3 style={styles.timelineTitle}>{item.title}</h3>
                <p style={styles.timelineText}>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* What We Cover */}
      <section style={styles.section}>
        <div style={styles.sectionHead}>
          <div style={styles.sectionEyebrow}>CONTENT</div>
          <h2 style={styles.sectionTitle}>What We Cover</h2>
          <div style={styles.sectionRule} />
          <p style={styles.sectionSub}>Explore our rich library of Tamil political content</p>
        </div>
        <div style={styles.grid4}>
          {[
            { icon: '🎤', title: 'SPEECHES', text: 'Historic and modern speeches from Tamil political leaders' },
            { icon: '📜', title: 'ARCHIVE', text: 'Rare archival footage and recordings from Tamil Nadu\'s political history' },
            { icon: '⚡', title: 'SHORTS', text: 'Quick clips and highlights from key political moments' },
            { icon: '🎬', title: 'REELS', text: 'Short-form content for the modern viewer on the go' },
          ].map((item, i) => (
            <div key={i} style={styles.catCard} onMouseEnter={e => { e.currentTarget.style.borderColor = C.gold2; e.currentTarget.style.transform = 'translateY(-4px)'; }} onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = 'none'; }}>
              <span style={styles.catIcon}>{item.icon}</span>
              <div style={styles.catTitle}>{item.title}</div>
              <p style={styles.catText}>{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Team */}
      <section style={styles.sectionDark}>
        <div style={styles.sectionHead}>
          <div style={styles.sectionEyebrow}>PEOPLE</div>
          <h2 style={styles.sectionTitle}>Our Team</h2>
          <div style={styles.sectionRule} />
          <p style={styles.sectionSub}>Passionate about Tamil culture and political heritage</p>
        </div>
        <div style={styles.grid3}>
          {[
            { name: 'Founder & CEO', role: 'Visionary Leader', text: 'Passionate about preserving Tamil political heritage for future generations.' },
            { name: 'Content Director', role: 'Curator & Archivist', text: 'Dedicated to sourcing and curating authentic Tamil political content.' },
            { name: 'Technology Lead', role: 'Platform Builder', text: 'Building the technology that makes Tamil political heritage accessible to all.' },
          ].map((m, i) => (
            <div key={i} style={styles.teamCard} onMouseEnter={e => { e.currentTarget.style.borderColor = C.gold2; e.currentTarget.style.transform = 'translateY(-4px)'; }} onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = 'none'; }}>
              <div style={styles.teamAvatar}>👤</div>
              <div style={styles.teamName}>{m.name}</div>
              <div style={styles.teamRole}>{m.role}</div>
              <p style={styles.cardText}>{m.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Contact */}
      <section style={styles.section}>
        <div style={styles.sectionHead}>
          <div style={styles.sectionEyebrow}>CONNECT</div>
          <h2 style={styles.sectionTitle}>Get In Touch</h2>
          <div style={styles.sectionRule} />
        </div>
        <div style={styles.grid2}>
          <div style={styles.contactCard}>
            <div style={styles.contactTitle}>📧 Contact Us</div>
            {[['General Inquiries', 'contact@nethajiprime.com'], ['Content Submissions', 'content@nethajiprime.com'], ['Business', 'business@nethajiprime.com']].map(([label, email]) => (
              <div key={email} style={{ marginBottom: '14px' }}>
                <div style={{ color: C.muted, fontSize: '11px', letterSpacing: '1px', marginBottom: '4px', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '700' }}>{label.toUpperCase()}</div>
                <a href={`mailto:${email}`} style={styles.link} onMouseEnter={e => e.target.style.color = C.gold} onMouseLeave={e => e.target.style.color = C.gold2}>{email}</a>
              </div>
            ))}
          </div>
          <div style={styles.contactCard}>
            <div style={styles.contactTitle}>🌐 Follow Us</div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {[['📺', 'YouTube'], ['📸', 'Instagram'], ['🐦', 'Twitter / X'], ['📘', 'Facebook']].map(([icon, name]) => (
                <a key={name} href="#" style={styles.socialBtn} onMouseEnter={e => { e.currentTarget.style.borderColor = C.gold2; e.currentTarget.style.color = C.gold; }} onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.gold2; }}>
                  {icon} {name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerLogo}>NETHAJI PRIME OTT</div>
        <p style={styles.footerSub}>Politics · Astrology · Law · Entertainment · All in One Stream — For Generations to Come</p>
        <p style={{ ...styles.footerSub, marginTop: '8px', fontSize: '11px' }}>© 2026 Nethaji Prime. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default About;